import React from 'react';
import { Helmet } from 'react-helmet';
import './AboutUs.css';
import { 
  FaRocket, 
  FaGlobe, 
  FaGraduationCap, 
  FaUsers, 
  FaLightbulb,
  FaAward,
  FaCheckCircle,
  FaHandshake,
  FaArrowRight
} from 'react-icons/fa';

const AboutUs = () => (
  <div className="about-us-page">
    <Helmet>
      <title>About Us - InternCourse</title>
      <meta name="description" content="Learn more about InternCourse, our mission, values, and how we empower students globally." />
    </Helmet>

    {/* Modern Hero Section */}
    <header className="about-hero">
      <div className="hero-container">
        <span className="hero-badge">
          <FaRocket className="badge-icon" /> Rethinking Internships
        </span>
        <h1>
          Empowering the Next Generation of <span className="gradient-text">Global Professionals</span>
        </h1>
        <p>
          Bridging the gap between academic theory and practical industry excellence through real-world experiential learning.
        </p>
      </div>
    </header>

    <div className="about-content-container">
      {/* Purpose Bento Section */}
      <section className="purpose-section">
        <div className="purpose-grid">
          {/* Mission Card */}
          <div className="bento-card mission-card">
            <div className="icon-badge green">
              <FaRocket />
            </div>
            <h2>Our Mission</h2>
            <p>
              Deliver accessible, practical, and affordable career ecosystems that empower learners to build real-world skills, execute portfolio projects, and unlock lifelong employment opportunities.
            </p>
            <div className="card-footer-item">
              <FaCheckCircle className="check-icon" /> Industry-Vetted Curriculum
            </div>
          </div>

          {/* Vision Card */}
          <div className="bento-card vision-card">
            <div className="icon-badge blue">
              <FaGlobe />
            </div>
            <h2>Our Vision</h2>
            <p>
              To create a world where geographic location and institutional background never dictate career potential. We aim to democratize technical and professional growth globally.
            </p>
            <div className="card-footer-item">
              <FaCheckCircle className="check-icon" /> Universal Skill Accessibility
            </div>
          </div>
        </div>
      </section>

      {/* Impact Stats Banner */}
      <section className="stats-banner">
        <div className="stats-grid">
          <div className="stat-item">
            <h3>12K+</h3>
            <p>Students Trained</p>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <h3>95%</h3>
            <p>Completion Rate</p>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <h3>12+</h3>
            <p>Domain Tracks</p>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <h3>4.9 ★</h3>
            <p>Learner Rating</p>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="values-section">
        <div className="section-header">
          <span className="sub-title">What Drives Us</span>
          <h2>Our Core Values</h2>
        </div>

        <div className="values-grid">
          <div className="bento-card value-card">
            <div className="value-icon-wrapper">
              <FaGraduationCap />
            </div>
            <h3>Quality Above All</h3>
            <p>Every assignment and project is meticulously crafted alongside corporate industry specialists.</p>
          </div>

          <div className="bento-card value-card">
            <div className="value-icon-wrapper">
              <FaUsers />
            </div>
            <h3>Student-First Approach</h3>
            <p>Your growth is our primary KPI. We provide 1-on-1 feedback, mentorship, and support.</p>
          </div>

          <div className="bento-card value-card">
            <div className="value-icon-wrapper">
              <FaLightbulb />
            </div>
            <h3>Continuous Innovation</h3>
            <p>We continuously adapt our modules to mirror evolving tech trends and market requirements.</p>
          </div>
        </div>
      </section>

      {/* Call to Action Box */}
      <section className="about-cta-section">
        <div className="cta-card">
          <div className="cta-content">
            <div className="cta-badge">
              <FaHandshake /> Start Today
            </div>
            <h2>Ready to Transform Your Career Path?</h2>
            <p>Explore our programs, gain hands-on expertise, and earn verified certifications.</p>
          </div>
          <a href="#fields" className="cta-button">
            Browse Programs <FaArrowRight />
          </a>
        </div>
      </section>
    </div>
  </div>
);

export default AboutUs;